import { PayloadAction } from '@reduxjs/toolkit';
import { HeaderType } from '../types';

export const toggleSidebar = (state: HeaderType, action: PayloadAction<boolean>) => {
  state.showSidebar = action.payload
};
